import { FunctionComponent, useMemo } from 'react'
import { WChip, WDropdown } from '@alice-health/wonderland-react'
// `import type`: importing values from wonderland breaks SSR.
import type {
  WDropdownCustomEvent,
  WDropdownValue
} from '@alice-health/wonderland'

interface DropdownChipItem {
  label: string
  value: string
}

interface DropdownChipProps {
  /** Chip text while no item is selected */
  placeholder: string
  items: DropdownChipItem[]
  value?: string
  disabled?: boolean
  onChange: (item: DropdownChipItem) => void
}

const DropdownChip: FunctionComponent<DropdownChipProps> = ({
  placeholder,
  items,
  value,
  disabled = false,
  onChange
}) => {
  const selected = useMemo(
    () => items.find(item => item.value === value),
    [items, value]
  )

  const onWChange = (event: WDropdownCustomEvent<WDropdownValue>) => {
    const nextValue = String(event.detail)
    const nextItem = items.find(item => item.value === nextValue)

    if (nextItem) {
      onChange(nextItem)
    }
  }

  const chip = (
    <WChip
      className='shrink-0'
      label={selected?.label || placeholder}
      trailingIcon='icChevronArrowDown'
      disabled={disabled}
    />
  )

  // `WDropdown` opens on its own slot click and ignores the child `disabled`.
  if (disabled) {
    return chip
  }

  return (
    <WDropdown
      className='shrink-0'
      items={items}
      value={value}
      onWChange={onWChange}
    >
      {chip}
    </WDropdown>
  )
}

export { DropdownChip }
export type { DropdownChipItem, DropdownChipProps }
